import { render } from "./DictManagement.vue?vue&type=template&id=e5227b1e&scoped=true"
import script from "./DictManagement.vue?vue&type=script&lang=js"
export * from "./DictManagement.vue?vue&type=script&lang=js"

import "./DictManagement.vue?vue&type=style&index=0&id=e5227b1e&scoped=true&lang=css"

import exportComponent from "/Users/Zhuanz/Desktop/himoney/aidata/loan-management/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5227b1e"]])

export default __exports__